import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { translations as sidenavTranslations } from "./locales/sidenav";
import { translations as chatTranslations } from "./locales/chat";

import { translations as appointmentTranslations } from "./locales/appointment";
import { translations as loginTranslations } from "./locales/login";
import { translations as todaySectionTranslations } from "./locales/home";
import { translations as healthInfoTranslations } from "./locales/healthInfo";
import { translations as dietInfoTranslations } from "./locales/dietInfo";
import { translations as testReportsTranslations } from "./locales/testReports";
import { translations as prescriptionsTranslations } from "./locales/prescriptions";
import { translations as notificationsTranslations } from "./locales/notifications";
import { translations as assessmentReminderPopupTranslations } from "./locales/assessmentReminderPopup";

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          // here we will place our english translations...
          onboard: {
            COMMON: {
              goBack: "Go Back",
            },
            LANG_PREF: {
              question: "In which language would you use the app?",
            },
            NAME: {
              question: "What is your name?",
              firstNameLbl: "First Name",
              middleNameLbl: "Middle Name",
              lastNameLbl: "Last Name",
            },
            TREATING_DOC: {
              question: "Who is your current doctor?",
              options: {
                DR000001: "Dr. S.M. Akerkar",
                DR000002: "Dr. Divya Lala",
                DR000003: "Dr. Deepak Malgutte",
                DR000004: "Dr. Archana Sonawale",
                DR000005: "Dr. Aarti A. Zope",
                DR000007: "Dr. Prashant N. Chhajed",
                DR000008: "Dr. Richa Gupta",
                DR000009: "Dr. Riya Shah",
                DR000010: "Dr. Sachin K Katarkar",
                DR000011: "Dr. Aarti Zope",
                DR000012: "Dr. G Manoj",
                DR000013: "Dr. Harshil Vora",
                DR000014: "Dr. Ankur M Doshi",
                DR000015: "Dr. Nilesh Nolkha",
                DR000016: "Dr. Reena Karkhele Jaybhaye",
                DR000017: "Dr. Chitranjan Das",
                DR000018: "Dr. Puneet Mashru",
                DR000019: "Dr. Smruti S Ramteke",
                DR000020: "Dr. Kailash Kothari",
                DR000021: "Dr. Narendra Vadlamudi",
                DR000022: "Dr. Ujwala Kale",
                DR000023: "Dr. Vrushal Umesh Kale",
                DR000024: "Dr. Sanjay Ramteke",
                DR000025: "Dr. Smruti Ramteke",
                DR000026: "Dr. Pranit Khandait",
                DR000027: "Dr. Ketki Ambulkar Telang",
                DT000006: "Pranjal Mutha",
                NEW_PATIENT: "No. I'm a new patient.",
              },
            },
            KNOWS_THE_DOCTORS: {
              question: "Do you know which doctor you want to register for?",
              options: {
                yes: "Yes",
                no: "No",
              },
            },
            CHOOSE_DOC: {
              question: "Choose a Doctor",
              options: {
                DR000001: "Dr. S.M. Akerkar",
                DR000002: "Dr. Divya Lala",
                DR000003: "Dr. Deepak Malgutte",
                DR000004: "Dr. Archana Sonawale",
                DR000005: "Dr. Aarti A. Zope",
                DR000007: "Dr. Prashant N. Chhajed",
                DR000008: "Dr. Richa Gupta",
                DR000009: "Dr. Riya Shah",
                DR000010: "Dr. Sachin K Katarkar",
                DR000011: "Dr. Aarti Zope",
                DR000012: "Dr. G Manoj",
                DR000013: "Dr. Harshil Vora",
                DR000014: "Dr. Ankur M Doshi",
                DR000015: "Dr. Nilesh Nolkha",
                DR000016: "Dr. Reena Karkhele Jaybhaye",
                DR000017: "Dr. Chitranjan Das",
                DR000018: "Dr. Puneet Mashru",
                DR000019: "Dr. Smruti S Ramteke",
                DR000020: "Dr. Kailash Kothari",
                DR000021: "Dr. Narendra Vadlamudi",
                DR000022: "Dr. Ujwala Kale",
                DR000023: "Dr. Vrushal Umesh Kale",
                DR000024: "Dr. Sanjay Ramteke",
                DR000025: "Dr. Smruti Ramteke",
                DR000026: "Dr. Pranit Khandait",
                DR000027: "Dr. Ketki Ambulkar Telang",
              },
            },
            TREATING_LOC: {
              question: "Where are you taking the treatment from?",
              options: {
                CC000001: "Mumbai Arthritis Clinic (Bhandup)",
                CC000002: "Ajit Scanning Center (Kalyan)",
                CC000000: "Online",
                CC000003: "Icon Hospital (Dombivali)",
                CC000004: "Shreyas Health Care Clinic (Badlapur)",
                CC000005: "Suchak Polyclinic & Hospital(Malad)",
                CC000006: "Bliss Clinic (Thane)",
                CC000008: "Lung Care and Sleep Centre (Santacruz)",
                CC000009: "Spandan Clinic (Airoli)",
                CC000010: "AIMS (Thane)",
                CC000011: "Sigma Hospital (Mulund West)",
                CC000012: "Good Health Clinics (Bhandup West)",
                CC000013: "Good Health Clinics (Bhandup East)",
                CC000014: "Nirjara Multispecialty Clinic (Kandivali West)",
                CC000015: "Advanced arthritis and Rheumatology Center",
                CC000017: "AMORAC (Mumbai)",
                CC000018: "ELIOS Hospital (Nagpur)",
                CC000019: "PAIN CLINIC OF INDIA (Chembur)",
                CC000020: "Dr.Das’s Pain Care Clinic (Thane)",
                CC000021:
                  "Sreshtha Arthritis and Rheumatology Clinic (Vijayawada)",
                CC000022: "RheuGlow Clinic (Palava)",
                CC000023: "Gleneagles Hospital (Parel)",
                CC000024: "ELIOS Hospital (Nagpur)",
                //Old values
                // CC000003: "Jivdaya Clinic (Ghatkopar)",
                // CC000004: "Bethany (Thane)",
                // CC000005: "Godrej (Vikhroli)",
                // CC000006: "Fortis (Mulund)",
                // CC000007: "Icon Hospital (Dombivali)",
              },
            },
            PREF_TREATING_LOC: {
              question:
                "From which IC4 clinic would you prefer to receive the treatment?",
              options: {
                CC000001: "Mumbai Arthritis Clinic (Bhandup)",
                CC000002: "Ajit Scanning Center (Kalyan)",
                CC000000: "Online",
                CC000003: "Icon Hospital (Dombivali)",
                CC000004: "Shreyas Health Care Clinic (Badlapur)",
                CC000005: "Suchak Polyclinic & Hospital (Malad)",
                CC000006: "Bliss Clinic (Thane)",
                CC000008: "Lung Care and Sleep Centre (Santacruz)",
                CC000009: "Spandan Clinic (Airoli)",
                CC000010: "AIMS (Thane)",
                CC000011: "Sigma Hospital (Mulund West)",
                CC000012: "Good Health Clinics (Bhandup West)",
                CC000013: "Good Health Clinics (Bhandup East)",
                CC000014: "Nirjara Multispecialty Clinic (Kandivali West)",
                CC000015: "Advanced arthritis and Rheumatology Center",
                CC000017: "AMORAC (Mumbai)",
                CC000018: "ELIOS Hospital (Nagpur)",
                CC000019: "PAIN CLINIC OF INDIA (Chembur)",
                CC000020: "Dr.Das’s Pain Care Clinic (Thane)",
                CC000021:
                  "Sreshtha Arthritis and Rheumatology Clinic (Vijayawada)",
                CC000022: "RheuGlow Clinic (Palava)",
                CC000023: "Gleneagles Hospital (Parel)",
                CC000024: "ELIOS Hospital (Nagpur)",
                //Old values
                // CC000003: "Jivdaya Clinic (Ghatkopar)",
                // CC000004: "Bethany (Thane)",
                // CC000005: "Godrej (Vikhroli)",
                // CC000006: "Fortis (Mulund)",
                // CC000007: "Icon Hospital (Dombivali)",
              },
            },
            EXISTING_PATIENT: {
              question:
                "Are you currently taking treatment from <Doctor Name>?",
              options: {
                yes: "Yes",
                no: "No",
              },
            },
            PID: {
              question: "What is your current Patient ID?",
              description1:
                "You will find it behind the front cover of your patient file. It will be below the barcode on the white sticker.",
              description2:
                "If you are not able to find it, please take help of the receptionist.",
              inputLbl: "Patient ID no.",
              inputLbl1: "Re-type Patient ID",
              alreadyExists:
                "Patient already registered. Please log in using your Patient App ID", //TODO: Link to Login, Put in new line
              appIdNotFound:
                "Patient ID not found. Please re-enter your ID or talk to the receptionist", //TODO: Put in new line
              doesnotHavePID1:
                "I do not have a registration ID from the clinic or from the website.",
              doesnotHavePID2:
                "(If you click this a new profile will be create for you that does not have earlier medical records.)",
            },
            GENDER: {
              question: "What is your gender?",
              options: {
                male: "Male",
                female: "Female",
                other: "Other",
              },
            },
            MOBILE: {
              question: "What is your mobile Number?",
              inputLbl: "Mobile no.",
              error: "Mobile number seems invalid",
            },
            VERIFY_MOBILE: {
              question: "Verify your mobile number",
              description: "Please enter OTP",
              resendCTA: "Resend OTP",
            },
            EMAIL: {
              question: "What is your email ID?",
              inputLbl1: "Email ID",
              inputLbl2: "Re-type Email ID",
              inputLbl3: "Email ID",
            },
            ADDRESS: {
              question1: "Where do you live?",
              pinCodeLbl: "Enter your pin code",
              pinCodeLocationLbl: "Enter your pin code or locality",
              question2: "Is this your locality? ",
              localityLbl: "Area",
              submitButtonText: "Yes, My locality is correct",
            },
            REPORTS: {
              std_note:
                "Your reports have been seen by Dr. Akerkar. Please continue with the same medications.",
            },
          },
          ...sidenavTranslations["EN"],
          ...chatTranslations["EN"],
          ...appointmentTranslations["EN"],
          ...loginTranslations["EN"],
          ...todaySectionTranslations["EN"],
          ...healthInfoTranslations["EN"],
          ...dietInfoTranslations["EN"],
          ...testReportsTranslations["EN"],
          ...prescriptionsTranslations["EN"],
          ...notificationsTranslations["EN"],
          ...assessmentReminderPopupTranslations["EN"],
        },
      },
      mr: {
        translation: {
          // here we will place our marathi translations...
          onboard: {
            COMMON: {
              goBack: "मागे जा",
            },
            LANG_PREF: {
              question: "तुम्ही अँप कोणत्या भाषेत वापराल?",
            },
            NAME: {
              question: "तुमचे नाव काय आहे?",
              firstNameLbl: "पहिले नाव",
              middleNameLbl: "मधले नाव",
              lastNameLbl: "आडनाव",
            },
            CHOOSE_DOC: {
              question: "डॉक्टरांची निवड करा",
              options: {
                DR000001: "डॉ. आकेरकर",
                DR000002: "डॉ दिव्या लाला",
                DR000003: "डॉ. दीपक मालगुट्टे",
                DR000004: "डॉ. अर्चना सोनावळे",
                DR000005: "डॉ. आरती ए. झप्पे",
                DR000007: "डॉ. प्रशांत एन.छाजेड",
                DR000008: "डॉ. रिचा गुप्ता ",
                DR000009: "डॉ. रिया शाह",
                DR000010: "डॉ. सचिन के कातरकर",
                DR000011: "डॉ. आरती झप्पे",
                DR000012: "डॉ जी मनोज",
                DR000013: "डॉ. हर्षिल वोरा",
                DR000014: "डॉ. अंकुर एम. दोशी",
                DR000015: "डॉ. निलेश नोलखा",
                DR000016: "डॉ. रीना कर्खेले जयभाये",
                DR000017: "डॉ. चित्रंजन दास",
                DR000018: "डॉ. पुनीत मशरू",
                DR000019: "डॉ. स्मृती एस रामटेके",
                DR000020: "डॉ. कैलाश कोठारी",
                DR000021: "डॉ. नरेंद्र वडलमुडी",
                DR000022: "डॉ. उज्वला काले",
                DR000023: "डॉ. वृषल उमेश काले",
                DR000024: "डॉ. संजय रामटेके",
                DR000025: "डॉ. स्मृती रामटेके",
                DR000026: "डॉ. प्रणीत खंडाईत",
                DR000027: "डॉ. केतकी अंबुलकर तेलंग",
              },
            },
            PREF_TREATING_LOC: {
              question:
                "तुम्ही कोणत्या IC4 क्लिनिकमधून उपचार घेण्यास प्राधान्य द्याल?",
              options: {
                CC000001: "भांडुप",
                CC000002: "कल्याण",
                CC000000: "ऑनलाइन",
                CC000003: "डोंबिवली",
                CC000004: "बदलापूर",
                CC000005: "मालाड",
                CC000006: "ब्लिस क्लिनिक (ठाणे)",
                CC000008: "सांताक्रूझ",
                CC000009: "स्पंदन क्लिनिक (ऐरोली)",
                CC000010: "एम्स (ठाणे)",
                CC000011: "सिग्मा हॉस्पिटल (मुलुंड वेस्ट)",
                CC000012: "गुड हेल्थ क्लिनिक्स (भांडुप वेस्ट)",
                CC000013: "गुड हेल्थ क्लिनिक्स (भांडुप ईस्ट)",
                CC000014: "निर्जरा मल्टीस्पेशालिटी क्लिनिक (कांदिवली पश्चिम)",
                CC000015: "अॅडव्हान्स्ड आर्थरायटिस अँड र्‍ह्युमेटोलॉजी सेंटर",
                CC000017: "अमोरॅक (मुंबई)",
                CC000018: "ELIOS हॉस्पिटल (नागपूर)",
                CC000019: "पेन क्लिनिक ऑफ इंडिया (चेंबूर)",
                CC000020: "डॉ. दास पेन केअर क्लिनिक (ठाणे)",
                CC000021:
                  "श्रेष्ठ आर्थराइटिस एंड रूमेटोलॉजी क्लिनिक (विजयवाड़ा)",
                CC000022: "RheuGlow क्लिनिक (पालावा)",
                CC000023: "ग्लेनइगल्स हॉस्पिटल (पारेल)",
                CC000024: "एलिओस हॉस्पिटल (नागपूर)",

                // CC000003: "घाटकोपर",
                // CC000004: "ठाणे (बेथनी)",
                // CC000005: "विक्रोळी (गोदरेज)",
                // CC000006: "मुलुंड",
                // CC000007: "डोंबिवली",
              },
            },
            EXISTING_PATIENT: {
              question:
                "तुम्ही सध्या <Doctor Name> यांच्याकडून उपचार घेत आहात का?",
              options: {
                yes: "होय",
                no: "नाही",
              },
            },
            TREATING_DOC: {
              question: "तुमचे सध्या डॉक्टर कोण आहेत?",
              options: {
                DR000001: "डॉ. आकेरकर",
                DR000002: "डॉ दिव्या लाला",
                DR000003: "डॉ. दीपक मालगुट्टे",
                DR000004: "डॉ. अर्चना सोनावळे",
                DR000005: "डॉ. आरती ए. झप्पे",
                DR000007: "डॉ.प्रशांत एन.छाजेड",
                DR000008: "डॉ. रिचा गुप्ता ",
                DR000009: "डॉ. रिया शाह",
                DR000010: "डॉ. सचिन के कातरकर",
                DR000011: "डॉ. आरती झप्पे",
                DR000012: "डॉ जी मनोज",
                DR000013: "डॉ. हर्षिल वोरा",
                DR000014: "डॉ. अंकुर एम. दोशी",
                DR000015: "डॉ. निलेश नोलखा",
                DR000016: "डॉ. रीना कर्खेले जयभाये",
                DR000017: "डॉ. चित्रंजन दास",
                DR000018: "डॉ. पुनीत मशरू",
                DR000019: "डॉ. स्मृती एस रामटेके",
                DR000020: "डॉ. कैलाश कोठारी",
                DR000021: "डॉ. नरेंद्र वडलमुडी",
                DR000022: "डॉ. उज्वला काले",
                DR000023: "डॉ. वृषल उमेश काले",
                DR000024: "डॉ. संजय रामटेके",
                DR000025: "डॉ. स्मृती रामटेके",
                DR000026: "डॉ. प्रणीत खंडाईत",
                DR000027: "डॉ. केतकी अंबुलकर तेलंग",
                DT000006: "प्रांजल मुथा",

                NEW_PATIENT: "नाही। मी नवीन पेशंट आहे",
              },
            },
            KNOWS_THE_DOCTORS: {
              question:
                "तुम्हाला माहीत आहे का तुम्हाला कोणत्या डॉक्टरची नोंदणी करायची आहे?",
              options: {
                yes: "होय",
                no: "नाही",
              },
            },
            TREATING_LOC: {
              question: "आपण कोठून उपचार घेत आहात?",
              options: {
                CC000001: "भांडुप",
                CC000002: "कल्याण",
                CC000000: "ऑनलाइन",
                CC000003: "डोंबिवली",
                CC000004: "बदलापूर",
                CC000005: "मालाड",
                CC000006: "ब्लिस क्लिनिक (ठाणे)",
                CC000008: "सांताक्रूझ",
                CC000009: "स्पंदन क्लिनिक (ऐरोली)",
                CC000010: "एम्स (ठाणे)",
                CC000011: "सिग्मा हॉस्पिटल (मुलुंड वेस्ट)",
                CC000012: "गुड हेल्थ क्लिनिक्स (भांडुप वेस्ट)",
                CC000013: "गुड हेल्थ क्लिनिक्स (भांडुप ईस्ट)",
                CC000014: "निर्जरा मल्टीस्पेशालिटी क्लिनिक (कांदिवली पश्चिम)",
                CC000015: "अॅडव्हान्स्ड आर्थरायटिस अँड र्‍ह्युमेटोलॉजी सेंटर",
                CC000017: "अमोरॅक (मुंबई)",
                CC000018: "ELIOS हॉस्पिटल (नागपूर)",
                CC000019: "पेन क्लिनिक ऑफ इंडिया (चेंबूर)",
                CC000020: "डॉ. दास पेन केअर क्लिनिक (ठाणे)",
                CC000021:
                  "श्रेष्ठ आर्थराइटिस एंड रूमेटोलॉजी क्लिनिक (विजयवाड़ा)",
                CC000022: "RheuGlow क्लिनिक (पालावा)",
                CC000023: "ग्लेनइगल्स हॉस्पिटल (पारेल)",
                CC000024: "एलिओस हॉस्पिटल (नागपूर)",

                // CC000003: "घाटकोपर",
                // CC000004: "ठाणे (बेथनी)",
                // CC000005: "विक्रोळी (गोदरेज)",
                // CC000006: "मुलुंड",
                // CC000007: "डोंबिवली",
              },
            },
            PID: {
              question: "तुमचा सध्याचा पेशंट आयडी काय आहे?",
              description1:
                "तुम्हाला तुमचा आय डी, तुमच्या पेशंट फाईलच्या पहिल्या कव्हर माघे सापडेल. ते पांढर्या स्टिकरवर बारकोड खाली असेल.",
              description2:
                "आपण ते शोधण्यास सक्षम नसल्यास, कृपया रिसेपशनिस्ट ची मदत घ्या",
              inputLbl: "पेशंट आयडी",
              inputLbl1: "पेशंट आयडीची पुष्टी करा",
              alreadyExists:
                "पेशंट आधीच नोंदणीकृत आहे. कृपया तुमचा पेशंट अँप आयडी वापरून लॉग इन करा.", // अँपवर
              appIdNotFound:
                "पेशंट आयडी सापडला नाही. कृपया तुमचा आयडी पुन्हा एंटर करा किंवा रिसेप्शनिस्टशी बोला",
              doesnotHavePID1:
                "माझ्याकडे क्लिनिक किंवा वेबसाइटवरून नोंदणी आयडी नाही.",
              doesnotHavePID2:
                "(तुम्ही यावर क्लिक केल्यास तुमच्यासाठी एक नवीन प्रोफाइल तयार केले जाईल ज्यात पूर्वीचे वैद्यकीय रेकॉर्ड नाहीत.)",
            },
            GENDER: {
              question: "लिंग",
              options: {
                male: "पुरुष",
                female: "स्त्री",
                other: "इतर",
              },
            },
            MOBILE: {
              question: "तुमचा मोबाईल नंबर काय आहे?",
              inputLbl: "मोबाईल नंबर",
              error: "मोबाईल नंबर अवैध वाटत आहे",
            },
            VERIFY_MOBILE: {
              question: "तुमचा मोबाईल नंबर सत्यापित करा",
              description: "कृपया OTP टाका",
              resendCTA: "OTP पुन्हा पाठवा",
            },
            EMAIL: {
              question: "तुमचा ईमेल आयडी काय आहे?",
              inputLbl1: "ईमेल आयडी",
              inputLbl2: "ईमेल आयडीची पुष्टी करा",
              inputLbl3: "ईमेल आयडी",
            },
            ADDRESS: {
              question1: "तुम्ही कुठे राहता?",
              pinCodeLbl: "तुमचा पिन कोड टाका",
              pinCodeLocationLbl: "आपला पिन कोड किंवा परिसर प्रविष्ट करा",
              question2: "हा तुमचा परिसर आहे का?",
              localityLbl: "परिसर",
              submitButtonText: "होय, माझा परिसर बरोबर आहे",
            },
            REPORTS: {
              std_note:
                "आपले रक्ताचे रिपोर्ट  डॉ. आकेरकर यांनी पाहिले आहेत. कृपया दिलेली औषधे सुरू ठेवा.",
            },
          },
          ...sidenavTranslations["MR"],
          ...chatTranslations["MR"],
          ...appointmentTranslations["MR"],
          ...loginTranslations["MR"],
          ...todaySectionTranslations["MR"],
          ...healthInfoTranslations["MR"],
          ...dietInfoTranslations["MR"],
          ...testReportsTranslations["MR"],
          ...prescriptionsTranslations["MR"],
          ...notificationsTranslations["MR"],
          ...assessmentReminderPopupTranslations["MR"],
        },
      },
      hi: {
        translation: {
          // here we will place our hindi translations...
          onboard: {
            COMMON: {
              goBack: "वापस जाओ",
            },
            LANG_PREF: {
              question: "आप किस भाषा में ऐप का उपयोग करेंगे?",
            },
            NAME: {
              question: "आपका नाम क्या हैं?",
              firstNameLbl: "पहला नाम",
              middleNameLbl: "मध्य नाम",
              lastNameLbl: "उपनाम",
            },
            CHOOSE_DOC: {
              question: "डॉक्टर चुनें",
              options: {
                DR000001: "डॉ. आकेरकर",
                DR000002: "डॉ दिव्या लाला",
                DR000003: "डॉ. दीपक मालगुट्टे",
                DR000004: "डॉ. अर्चना सोनावले",
                DR000005: "डॉ. आरती ए. ज़ोपे",
                DR000007: "डॉ. प्रशांत एन. छाजेड़",
                DR000008: "डॉ. रिचा गुप्ता ",
                DR000009: "डॉ. रिया शाह",
                DR000010: "डॉ. सचिन के कातरकर",
                DR000011: "डॉ. आरती ज़ोपे",
                DR000012: "डॉ. जी मनोज",
                DR000013: "डॉ. हर्षिल वोरा",
                DR000014: "डॉ. अंकुर एम. दोशी",
                DR000015: "डॉ. नीलेश नोलखा",
                DR000016: "डॉ. रीना कर्खेले जयभाये",
                DR000017: "डॉ. चित्रंजन दास",
                DR000018: "डॉ. पुनीत मशरू",
                DR000019: "डॉ. स्मृती एस रामटेके",
                DR000020: "डॉ. कैलाश कोठारी",
                DR000021: "डॉ. नरेंद्र वडलमूदि",
                DR000022: "डॉ. उज्वला काले",
                DR000023: "डॉ. वृषल उमेश काले",
                DR000024: "डॉ. संजय रामटेके",
                DR000025: "डॉ. स्मृति रामटेके",
                DR000026: "डॉ. प्रणित खंडाईत",
                DR000027: "डॉ. केतकी अंबुलकर तेलंग",
              },
            },
            PREF_TREATING_LOC: {
              question: "आप किस IC4 क्लिनिक से इलाज कराना पसंद करेंगे?",
              options: {
                CC000001: "भांडुप",
                CC000002: "कल्याण",
                CC000000: "ऑनलाइन",
                CC000003: "डोंबिवली",
                CC000004: "बदलापूर",
                CC000005: "मलाड",
                CC000006: "ब्लिस क्लिनिक (ठाणे)",
                CC000008: "सांताक्रूज़",
                CC000009: "स्पंदन क्लिनिक (ऐरोली)",
                CC000010: "एम्स (ठाणे)",
                CC000011: "सिग्मा हॉस्पिटल (मुलुंड वेस्ट)",
                CC000012: "गुड हेल्थ क्लिनिक्स (भांडुप वेस्ट)",
                CC000013: "गुड हेल्थ क्लिनिक्स (भांडुप ईस्ट)",
                CC000014: "निर्जरा मल्टीस्पेशलिटी क्लिनिक (कांदिवली पश्चिम)",
                CC000015: "एडवांस्ड आर्थराइटिस एंड रियूमेटोलॉजी सेंटर",
                CC000017: "अमोरॅक (मुंबई)",
                CC000018: "ELIOS हॉस्पिटल (नागपूर)",
                CC000019: "पेन क्लिनिक ऑफ इंडिया (चेंबूर)",
                CC000020: "डॉ. दास पेन केअर क्लिनिक (ठाणे)",
                CC000021:
                  "श्रेष्ठ आर्थरायटिस एंड रूमेटोलॉजी क्लिनिक (विजयवाडा)",
                CC000022: "RheuGlow क्लिनिक (पालावा)",
                CC000023: "ग्लेनइगल्स हॉस्पिटल (पारेल)",
                CC000024: "एलिओस हॉस्पिटल (नागपुर)",

                // Old Values
                // CC000001: "भांडुप",
                // CC000002: "कल्याण",
                // CC000000: "ऑनलाइन",
                // CC000003: "घाटकोपर",
                // CC000004: "ठाणे (बेथनी)",
                // CC000005: "विक्रोळी (गोदरेज)",
                // CC000006: "मुलुंड",
                // CC000007: "डोंबिवली",
              },
            },
            EXISTING_PATIENT: {
              question: "आप वर्तमानमें <Doctor Name> से उपचार करा रहे हैं?",
              options: {
                yes: "हां",
                no: "नहीं",
              },
            },
            TREATING_DOC: {
              question: "आपके वर्तमान डॉक्टर कौन हैं?",
              options: {
                DR000001: "डॉ. आकेरकर",
                DR000002: "डॉ दिव्या लाला",
                DR000003: "डॉ. दीपक मालगुट्टे",
                DR000004: "डॉ. अर्चना सोनावले",
                DR000005: "डॉ. आरती ए. ज़ोपे",
                DR000007: "डॉ. प्रशांत एन. छाजेड़",
                DR000008: "डॉ. रिचा गुप्ता ",
                DR000009: "डॉ. रिया शाह",
                DR000010: "डॉ. सचिन के कातरकर",
                DR000011: "डॉ. आरती ज़ोपे",
                DR000012: "डॉ. जी मनोज",
                DR000013: "डॉ. हर्षिल वोरा",
                DR000014: "डॉ. अंकुर एम. दोशी",
                DR000015: "डॉ. नीलेश नोलखा",
                DR000016: "डॉ. रीना कर्खेले जयभाये",
                DR000017: "डॉ. चित्रंजन दास",
                DR000018: "डॉ. पुनीत मशरू",
                DR000019: "डॉ. स्मृती एस रामटेके",
                DR000020: "डॉ. कैलाश कोठारी",
                DR000021: "डॉ. नरेंद्र वडलमूदि",
                DR000022: "डॉ. उज्वला काले",
                DR000023: "डॉ. वृषल उमेश काले",
                DR000024: "डॉ. संजय रामटेके",
                DR000025: "डॉ. स्मृति रामटेके",
                DR000026: "डॉ. प्रणित खंडाईत",
                DR000027: "डॉ. केतकी अंबुलकर तेलंग",
                DT000006: "प्रांजल मुथा",
                NEW_PATIENT: "नहीं। मैं एक नया पेशंट हूँ",
              },
            },
            KNOWS_THE_DOCTORS: {
              question:
                "क्या आप जानते हैं कि आप किस डॉक्टर के लिए रजिस्टर कराना चाहते हैं?",
              options: {
                yes: "हां",
                no: "नहीं",
              },
            },
            TREATING_LOC: {
              question: "आप कहां से उपचार ले रहे हैं?",
              options: {
                CC000001: "भांडुप",
                CC000002: "कल्याण",
                CC000000: "ऑनलाइन",
                CC000003: "डोंबिवली",
                CC000004: "बदलापूर",
                CC000005: "मलाड",
                CC000006: "ब्लिस क्लिनिक (ठाणे)",
                CC000008: "सांताक्रूज़",
                CC000009: "स्पंदन क्लिनिक (ऐरोली)",
                CC000010: "एम्स (ठाणे)",
                CC000011: "सिग्मा हॉस्पिटल (मुलुंड वेस्ट)",
                CC000012: "गुड हेल्थ क्लिनिक्स (भांडुप वेस्ट)",
                CC000013: "गुड हेल्थ क्लिनिक्स (भांडुप ईस्ट)",
                CC000014: "निर्जरा मल्टीस्पेशलिटी क्लिनिक (कांदिवली पश्चिम)",
                CC000015: "एडवांस्ड आर्थराइटिस एंड रियूमेटोलॉजी सेंटर",
                CC000017: "अमोरॅक (मुंबई)",
                CC000018: "ELIOS हॉस्पिटल (नागपूर)",
                CC000019: "पेन क्लिनिक ऑफ इंडिया (चेंबूर)",
                CC000020: "डॉ. दास पेन केअर क्लिनिक (ठाणे)",
                CC000021:
                  "श्रेष्ठ आर्थरायटिस एंड रूमेटोलॉजी क्लिनिक (विजयवाडा)",
                CC000022: "RheuGlow क्लिनिक (पालावा)",
                CC000023: "ग्लेनइगल्स हॉस्पिटल (पारेल)",
                CC000024: "एलिओस हॉस्पिटल (नागपुर)",

                // Old Values
                // CC000001: "भांडुप",
                // CC000002: "कल्याण",
                // CC000000: "ऑनलाइन",
                // CC000003: "घाटकोपर",
                // CC000004: "ठाणे (बेथनी)",
                // CC000005: "विक्रोळी (गोदरेज)",
                // CC000006: "मुलुंड",
                // CC000007: "डोंबिवली",
              },
            },
            PID: {
              question: "आपकी वर्तमान पेशंट आईडी क्या हैं?",
              description1:
                "आपको अपनी आईडी आपकी पेशंट फ़ाइल के सामने के कवर के पीछे मिलेगी। यह सफेद स्टिकर पर बारकोड के नीचे होगा|",
              description2:
                "यदि आप इसे खोजने में सक्षम नहीं हैं, तो कृपया रिसेपशनिस्ट की मदद ले|",
              inputLbl: "पेशंट आईडी",
              inputLbl1: "पेशंट आईडी की जाँच करें",
              alreadyExists:
                "पेशंट पहले से ही पंजीकृत है। कृपया अपनी पेशंट ऐप आईडी का उपयोग करके लॉग इन करें।",
              appIdNotFound:
                "पेशंट आईडी नहीं मिला। कृपया अपना आईडी दोबारा दर्ज करें या रिसेप्शनिस्ट से बात करें।",
              doesnotHavePID1:
                "मेरे पास क्लिनिक या वेबसाइट से कोई रजिस्ट्रीकरण आईडी नहीं है।",
              doesnotHavePID2:
                "(यदि आप इस पर क्लिक करते हैं तो आपके लिए एक नई प्रोफ़ाइल बन जाएगी जिसमें पहले के मेडिकल रिकॉर्ड नहीं होंगे।)",
            },
            GENDER: {
              question: "लिंग",
              options: {
                male: "पुरुष",
                female: "महिला",
                other: "अन्य",
              },
            },
            MOBILE: {
              question: "आपका मोबाइल नम्बर क्या हैं?",
              inputLbl: "मोबाईल नंबर",
              error: "मोबाईल नंबर अमान्य लगता हैं।",
            },
            VERIFY_MOBILE: {
              question: "अपना मोबाइल नंबर सत्यापित करें।",
              description: "कृपया ओटीपी दर्ज करें",
              resendCTA: "ओटीपी पुनः भेजें",
            },
            EMAIL: {
              question: "ईमेल आई डी",
              inputLbl1: "ईमेल आईडी",
              inputLbl2: "ईमेल आईडी की जाँच करें",
              inputLbl3: "ईमेल आईडी",
            },
            ADDRESS: {
              question1: "आप कहाँ रहते हैं?",
              pinCodeLbl: "अपना पिन कोड दर्ज करें",
              pinCodeLocationLbl: "अपना पिन कोड या लोकलिटी दर्ज करें",
              question2: "क्या यह आपका इलाका हैं?",
              localityLbl: "इलाका",
              submitButtonText: "हाँ, मेरा इलाका सही हैं",
            },
            REPORTS: {
              std_note:
                "आपकी रिपोर्ट को डॉ. आकेरकर ने देखी है। कृपया दी गयी दवा को चालू रखिए।",
            },
          },
          ...sidenavTranslations["HI"],
          ...chatTranslations["HI"],
          ...appointmentTranslations["HI"],
          ...loginTranslations["HI"],
          ...todaySectionTranslations["HI"],
          ...healthInfoTranslations["HI"],
          ...dietInfoTranslations["HI"],
          ...testReportsTranslations["HI"],
          ...prescriptionsTranslations["HI"],
          ...notificationsTranslations["HI"],
          ...assessmentReminderPopupTranslations["HI"],
        },
      },
    },
  });

export default i18n;
